import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../../helpers/Firebase';
import { servicePath } from '../../../constants/defaultValues';
import { NotificationManager } from '../../../components/common/react-notifications';
import { COM_AREA_LIST, COM_AREA_ADD, COM_AREA_UPDATE } from '../../actions';
import {
    ComAreaListSuccess, ComAreaListError,
    ComAreaAddSuccess, ComAreaAddError,
    ComAreaUpdateSuccess, ComAreaUpdateError,
} from '../../actions';

function getToken(auth) {
    return new Promise((resolve, reject) => {
        const unsubscribe = auth.onAuthStateChanged(user => {
            user.getIdToken().then((token) => { unsubscribe(); resolve(token); });
        }, reject);
    });
}

const onListAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'communication/area/list', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    }).then(r => r.json()).catch(err => console.log(err));
    return { data: response };
};

const onAddAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'communication/area/add', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    }).then(r => r.json()).catch(err => console.log(err));
    return { data: response };
};

const onUpdateAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'communication/area/update', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    }).then(r => r.json()).catch(err => console.log(err));
    return { data: response };
};

function* onList(data) {
    try {
        const response = yield call(onListAsync, data.payload);
        yield put(ComAreaListSuccess(response.data));
    } catch (error) { yield put(ComAreaListError(error)); }
}

function* onAdd(data) {
    try {
        const response = yield call(onAddAsync, data.payload);
        if (response.data.status === true) NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
        else NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
        yield put(ComAreaAddSuccess(response.data));
    } catch (error) { yield put(ComAreaAddError(error)); }
}

function* onUpdate(data) {
    try {
        const response = yield call(onUpdateAsync, data.payload);
        if (response.data.status === true) NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
        else NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
        yield put(ComAreaUpdateSuccess(response.data));
    } catch (error) { yield put(ComAreaUpdateError(error)); }
}

export function* watchList() { yield takeEvery(COM_AREA_LIST, onList); }
export function* watchAdd() { yield takeEvery(COM_AREA_ADD, onAdd); }
export function* watchUpdate() { yield takeEvery(COM_AREA_UPDATE, onUpdate); }

export default function* rootSaga() {
    yield all([fork(watchList), fork(watchAdd), fork(watchUpdate)]);
}
